<template>
  <div class="list-item">
    <div
      class="list-item-title text-ellipsis"
      :title="info.purchaseName"
      @click="toDetail(info)"
    >
      {{ info.purchaseName || '-' }}
    </div>
    <!-- 最新公告 -->
    <div class="newest-notice">
      <div
        class="notice-title text-ellipsis"
        :title="info.noticeVo.title"
        @click="toNoticeDetail(info)"
      >
        【最新公告】{{ info.noticeVo.title }}
      </div>
      <div class="notice-time">
        {{ timeFilter(info.noticeVo.publishTime) }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { toBiddogPage } from '@/utils/utils'
import { mapState } from 'vuex'

export default {
  name: 'FollowProjectItem',

  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState('system', ['systemTime'])
  },

  methods: {
    timeFilter(value) {
      const now = moment(this.systemTime)
      const start = moment(value)
      // 小时
      const hours = now.diff(start, 'hours')
      return hours < 24 ? hours + '小时前' : value
    },

    /**
     * 前往项目详情
     * @param {Object} item 项目列表单项
     */
    toDetail(project) {
      toBiddogPage(`/follow/project/${project.purchaseId}/detail`)
    },

    /**
     * 查看最新公告详情
     */
    toNoticeDetail(project) {
      const noticeVo = project.noticeVo || {}
      toBiddogPage(`/notice/${noticeVo.noticeId}/notice-detail`)
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  padding: 16px 0;
  border-bottom: 1px solid $info-fourth-color;

  .list-item-title {
    display: inline-block;
    font-size: 16px;
    @include text-bold;
    cursor: pointer;
    width: 100%;

    &:hover {
      color: $primary-color;
    }
  }

  .newest-notice {
    margin-top: 8px;

    .notice-title {
      color: $text-second-color;
      font-size: 14px;
      margin-left: -6px;
      cursor: pointer;

      &:hover {
        color: $primary-color;
      }
    }

    .notice-time {
      font-size: 12px;
      color: $text-third-color;
      margin-top: 16px;
    }
  }
}
</style>
